import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ffcc33e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-2 mt-5" }, "Do any of the following barriers significantly affect your ability to live independently?", -1))
const _hoisted_2 = { class: "columns is-mobile" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "columns is-mobile" }
const _hoisted_5 = { class: "mt-3 infoBox" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total Income", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "columns is-mobile" }
const _hoisted_9 = { class: "mt-3 infoBox" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total Expenses", -1))

import { ref, onMounted, computed } from "vue";
import FormTextField from "@/components/FormTextField.vue";
import FormRadioGroupField from "@/components/FormRadioGroupField.vue";
import FormCheckboxField from "@/components/FormCheckboxField.vue";
import FormCheckboxGroupField from "@/components/FormCheckboxGroupField.vue";
import { type HmisClassifiers } from "../model";


export default /*#__PURE__*/_defineComponent({
  __name: 'HmisClassifierQuestions',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: Partial<HmisClassifiers>
}



const answers = ref<HmisClassifiers>({
    livingPlace: null,
    livingDuration: null,
    homelessnessStart: {
      status: null,
      dateStarted: "",
    },
    timesOnTheStreet: null,
    monthsOnTheStreet: null,
    healthInsurance: [],
    barriers: {
      'Alcohol use':                  {hasBarrier: false, stillPresent: false},
      'Drug use':                     {hasBarrier: false, stillPresent: false},
      'Chronic health condition':     {hasBarrier: false, stillPresent: false},
      'Physical disability':          {hasBarrier: false, stillPresent: false},
      'Developmental disability':     {hasBarrier: false, stillPresent: false},
      'HIV / AIDS':                   {hasBarrier: false, stillPresent: false},
      'Mental health':                {hasBarrier: false, stillPresent: false},
    },
    domesticViolence: null,
    veteran: null,
    income: {
      status: null,
      categories: {
        'Earned income (i.e. employment income)': {hasIncome: false, description: "", amount: ""},
        'Unemployment insurance':                 {hasIncome: false, description: "", amount: ""},
        'Supplemental Security Income (SSI)':     {hasIncome: false, description: "", amount: ""},
        'Social Security Disability Insurance':   {hasIncome: false, description: "", amount: ""},
        'Veteran\'s Disability Payment':          {hasIncome: false, description: "", amount: ""},
        'Private Disability Insurance':           {hasIncome: false, description: "", amount: ""},
        'Worker\'s Compensation':                 {hasIncome: false, description: "", amount: ""},
        'TANF':                                   {hasIncome: false, description: "", amount: ""},
        'General Assistance':                     {hasIncome: false, description: "", amount: ""},
        'Retirement income from Social Security': {hasIncome: false, description: "", amount: ""},
        'Veteran\'s Pension':                     {hasIncome: false, description: "", amount: ""},
        'Other Pension':                          {hasIncome: false, description: "", amount: ""},
        'Child Support':                          {hasIncome: false, description: "", amount: ""},
        'Alimony or other spousal support':       {hasIncome: false, description: "", amount: ""},
        'Other income':                           {hasIncome: false, description: "", amount: ""},
      }
    },
    benefits: {
      status: null,
      description: "",
    },
    expenses: {
      status: null,
      categories: {
        'Out-of-Pocket Medical Expenses': {hasExpense: false, description: "", amount: ""},
        'Rent':                           {hasExpense: false, description: "", amount: ""},
        'Security Deposit':               {hasExpense: false, description: "", amount: ""},
        'Mortgage':                       {hasExpense: false, description: "", amount: ""},
        'Utilities - Electric':           {hasExpense: false, description: "", amount: ""},
        'Utilities - Gas':                {hasExpense: false, description: "", amount: ""},
        'Utilities - Water':              {hasExpense: false, description: "", amount: ""},
        'Maintenance':                    {hasExpense: false, description: "", amount: ""},
        'Car Payment':                    {hasExpense: false, description: "", amount: ""},
        'Car Insurance':                  {hasExpense: false, description: "", amount: ""},
        'Groceries':                      {hasExpense: false, description: "", amount: ""},
        'Gasoline':                       {hasExpense: false, description: "", amount: ""},
        'Miscellaneous':                  {hasExpense: false, description: "", amount: ""},
      }
    },
    consentToShare: null
});

onMounted(() => {
  // Clone model (we can't mutate it directly)
  console.log("Mounted", props.modelValue);
    answers.value = {...answers.value, ...props.modelValue};
  }
);



const onChange = () => {
  console.log("CHANGE", answers);
  emit('update:modelValue', {...answers.value});
}

const listToObject = (strings: string[]) => {
  const result:any = {};
  for (let s of strings) {
    result[s] = s;
  }
  return result;
};

const totalIncome = computed(()=>{
  let total = 0;
  for (const income of Object.values(answers.value.income.categories)) {
    if (income.hasIncome && income.amount.trim().length > 0) {
      total += parseFloat(income.amount);
    }
  }
  return total;
});

const totalExpenses = computed(()=>{
  let total = 0;
  for (const expense of Object.values(answers.value.expenses.categories)) {
    if (expense.hasExpense && expense.amount.trim().length > 0) {
      total += parseFloat(expense.amount);
    }
  }
  return total;
})



return (_ctx: any,_cache: any) => {
  const _component_FormSelectField = _resolveComponent("FormSelectField")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FormSelectField, {
      label: "Where did you stay last night?",
      modelValue: answers.value.livingPlace,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((answers.value.livingPlace) = $event)),
      stacked: "",
      onChange: onChange,
      options: listToObject([
    'Place not meant for habitation',
    'Emergency shelter, including hotel or motel paid for with emergency shelter voucher, Host Home shelter',
    'Save Haven',
    'Foster care home or foster care group home',
    'Hospital or other residential non-psychiatric medical facility',
    'Jail, prison, or juvenile detention facility',
    'Long-term care facility or nursing home',
    'Psychiatric hospital or other psychiatric facility',
    'Substance abuse treatment facility or detox center',
    'Transitional housing for homeless persons (including homeless youth)',
    'Residential project or halfway house with no homeless criteria',
    'Hotel or motel paid for without emergency shelter voucher',
    'Host Home (non-crisis)',
    'Staying or living in a friend\'s room, apartment or house',
    'Rental by client, no ongoing housing subsidy',
    'Rental by client, with ongoing housing subsidy',
    'Owned by client, with ongoing housing subsidy',
    'Owned by client, no ongoing housing subsidy',
    'Client doesn\'t know',
    'Client prefers not to answer',
  ])
    }, null, 8, ["modelValue", "options"]),
    _createVNode(_component_FormSelectField, {
      class: "mt-5",
      label: "How long have you been staying there?",
      modelValue: answers.value.livingDuration,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((answers.value.livingDuration) = $event)),
      stacked: "",
      onChange: onChange,
      options: listToObject([
    'One night or less',
    'Two to six nights',
    'One week or more, but less than one month',
    'One month or more, but less than 90 days',
    '90 days or more, but less than one year',
    'One year or longer',
    'Client doesn\'t know',
    'Client prefers not to answer',
  ])
    }, null, 8, ["modelValue", "options"]),
    _createVNode(FormRadioGroupField, {
      class: "mt-5",
      label: "When did your homelessness start?",
      modelValue: answers.value.homelessnessStart.status,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((answers.value.homelessnessStart.status) = $event)),
      stacked: "",
      onChange: onChange,
      options: listToObject([
    'Enter date',
    'Client doesn\'t know',
    'Client prefers not to answer',
  ])
    }, {
      "first-option": _withCtx(() => [
        _createVNode(FormTextField, {
          modelValue: answers.value.homelessnessStart.dateStarted,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((answers.value.homelessnessStart.dateStarted) = $event)),
          autoFocus: "",
          onChange: onChange
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "options"]),
    _createVNode(_component_FormSelectField, {
      class: "mt-5",
      label: "How many times have you stayed on the street, or in a shelter, in the past 3 years?",
      modelValue: answers.value.timesOnTheStreet,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((answers.value.timesOnTheStreet) = $event)),
      stacked: "",
      onChange: onChange,
      options: listToObject([
      'One time',
      'Two times',
      'Three times',
      'Four or more times',
      'Client doesn\'t know',
      'Client prefers not to answer',
    ])
    }, null, 8, ["modelValue", "options"]),
    _createVNode(_component_FormSelectField, {
      class: "mt-5",
      label: "For how many months in total have you been on the street in the past 3 years?",
      modelValue: answers.value.monthsOnTheStreet,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((answers.value.monthsOnTheStreet) = $event)),
      stacked: "",
      onChange: onChange,
      options: listToObject([
			'1 month',
			'2 months',
			'3 months',
			'4 months',
			'5 months',
			'6 months',
			'7 months',
			'8 months',
			'9 months',
			'10 months',
			'11 months',
			'12 months or more',
      'Client doesn\'t know',
      'Client prefers not to answer',
    ])
    }, null, 8, ["modelValue", "options"]),
    _createVNode(FormCheckboxGroupField, {
      class: "mt-5",
      label: "Do you receive health insurance from any of the following?",
      modelValue: answers.value.healthInsurance,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((answers.value.healthInsurance) = $event)),
      stacked: "",
      onChange: onChange,
      options: listToObject([
			'Private - Individual',
			'Private - Employer',
			'Medicare',
			'Medicaid',
			'S-CHIP',
			'VHA',
			'State Funded',
			'Combined Children\'s Health Insurance / Medicaid Program',
			'IHS',
			'COBRA',
			'Wellcare',
			'None of the above',
      'Client doesn\'t know',
      'Client prefers not to answer',
    ])
    }, null, 8, ["modelValue", "options"]),
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.value.barriers, (barrier, barrierName) => {
      return (_openBlock(), _createElementBlock("div", { key: barrierName }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FormCheckboxField, {
            boxLabel: barrierName,
            modelValue: barrier.hasBarrier,
            "onUpdate:modelValue": ($event: any) => ((barrier.hasBarrier) = $event),
            onChange: onChange
          }, null, 8, ["boxLabel", "modelValue", "onUpdate:modelValue"]),
          (barrier.hasBarrier)
            ? (_openBlock(), _createBlock(FormCheckboxField, {
                key: 0,
                boxLabel: "Still Present",
                modelValue: barrier.stillPresent,
                "onUpdate:modelValue": ($event: any) => ((barrier.stillPresent) = $event),
                onChange: onChange
              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createVNode(FormRadioGroupField, {
      class: "mt-5",
      label: "Are you a survivor of domestic violence?",
      modelValue: answers.value.domesticViolence,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((answers.value.domesticViolence) = $event)),
      onChange: onChange,
      options: listToObject([
			'Yes',
      'No',
      'Client doesn\'t know',
      'Client prefers not to answer',
    ])
    }, null, 8, ["modelValue", "options"]),
    _createVNode(FormRadioGroupField, {
      class: "mt-5",
      label: "Are you a veteran, or in active military service?",
      modelValue: answers.value.veteran,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((answers.value.veteran) = $event)),
      onChange: onChange,
      options: {
      'Yes': 'YES',
      'No': 'NO',
      'Client doesn\'t know': 'NOT_SURE',
      'Client prefers not to say': 'PREFER_NOT_TO_SAY',
    }
    }, null, 8, ["modelValue"]),
    _createVNode(FormRadioGroupField, {
      class: "mt-5",
      label: "Do you currently have monthly income, from any source?",
      modelValue: answers.value.income.status,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((answers.value.income.status) = $event)),
      onChange: onChange,
      options: {
      'Yes': 'YES',
      'No': 'NO',
      'Client doesn\'t know': 'NOT_SURE',
      'Client prefers not to say': 'PREFER_NOT_TO_SAY',
    }
    }, null, 8, ["modelValue"]),
    (answers.value.income.status == 'YES')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.value.income.categories, (income, incomeName) => {
            return (_openBlock(), _createElementBlock("div", { key: incomeName }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(FormCheckboxField, {
                  boxLabel: incomeName,
                  modelValue: income.hasIncome,
                  "onUpdate:modelValue": ($event: any) => ((income.hasIncome) = $event),
                  onChange: onChange
                }, null, 8, ["boxLabel", "modelValue", "onUpdate:modelValue"]),
                (income.hasIncome)
                  ? (_openBlock(), _createBlock(FormTextField, {
                      key: 0,
                      placeholder: "Description",
                      modelValue: income.description,
                      "onUpdate:modelValue": ($event: any) => ((income.description) = $event),
                      onChange: onChange,
                      autoFocus: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (income.hasIncome)
                  ? (_openBlock(), _createBlock(FormTextField, {
                      key: 1,
                      placeholder: "Amount ($)",
                      modelValue: income.amount,
                      "onUpdate:modelValue": ($event: any) => ((income.amount) = $event),
                      onChange: onChange,
                      numeric: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(": $" + _toDisplayString(Math.round(_unref(totalIncome)*100)/100), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(FormRadioGroupField, {
      class: "mt-5",
      label: "Do you receive any non-cash benefits?",
      modelValue: answers.value.benefits.status,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((answers.value.benefits.status) = $event)),
      onChange: onChange,
      options: listToObject([
      'Yes',
      'No',
      'Client doesn\'t know',
      'Client prefers not to answer',
    ])
    }, {
      "first-option": _withCtx(() => [
        _createVNode(FormTextField, {
          placeholder: "Description",
          modelValue: answers.value.benefits.description,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((answers.value.benefits.description) = $event)),
          autoFocus: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "options"]),
    _createVNode(FormRadioGroupField, {
      class: "mt-5",
      label: "Do you currently have monthly expenses, from any source?",
      onChange: onChange,
      modelValue: answers.value.expenses.status,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((answers.value.expenses.status) = $event)),
      options: {
      'Yes': 'YES',
      'No': 'NO',
      'Client doesn\'t know': 'NOT_SURE',
      'Client prefers not to say': 'PREFER_NOT_TO_SAY',
    }
    }, null, 8, ["modelValue"]),
    (answers.value.expenses.status == 'YES')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.value.expenses.categories, (expense, expenseName) => {
            return (_openBlock(), _createElementBlock("div", { key: expenseName }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(FormCheckboxField, {
                  boxLabel: expenseName,
                  modelValue: expense.hasExpense,
                  "onUpdate:modelValue": ($event: any) => ((expense.hasExpense) = $event),
                  onChange: onChange
                }, null, 8, ["boxLabel", "modelValue", "onUpdate:modelValue"]),
                (expense.hasExpense)
                  ? (_openBlock(), _createBlock(FormTextField, {
                      key: 0,
                      placeholder: "Description",
                      modelValue: expense.description,
                      "onUpdate:modelValue": ($event: any) => ((expense.description) = $event),
                      onChange: onChange,
                      autoFocus: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (expense.hasExpense)
                  ? (_openBlock(), _createBlock(FormTextField, {
                      key: 1,
                      placeholder: "Amount ($)",
                      modelValue: expense.amount,
                      "onUpdate:modelValue": ($event: any) => ((expense.amount) = $event),
                      onChange: onChange,
                      numeric: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(": $" + _toDisplayString(Math.round(_unref(totalExpenses)*100)/100), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(FormRadioGroupField, {
      class: "mt-5",
      label: "Do you consent to share this information?",
      onChange: onChange,
      modelValue: answers.value.consentToShare,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((answers.value.consentToShare) = $event)),
      options: {
      'Yes': 'YES',
      'No': 'NO'
    }
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})